<template>
  <div class="ao__table-container" v-html="props.payload.rendered" />
</template>


<script setup lang="ts">
const props = defineProps<{
  payload?: any
}>()
</script>

<style lang="postcss">
</style>
